import { useEffect, useState } from 'react';
import { getExtProvider, IMultisigExtension } from 'services/safeExtensionService';

const useAsignaProvider = () => {
  const [provider, setProvider] = useState<IMultisigExtension>();

  useEffect(() => {
    function handler() {
      setProvider(getExtProvider());
    }

    window.addEventListener('load', handler);

    return () => {
      window.removeEventListener('load', handler);
    };
  }, []);

  return provider;
};

export default useAsignaProvider;
